import React, { useEffect, useState } from "react";
import Sidebar from "../../../Shared/Sidebar";
import Preloader from "../../../Shared/Preloader/Preloader";
import Navbar from "../../../Shared/Navbar/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Button,
  Modal,
  Form,
  Col,
  Row,
  Table,
  Spinner,
} from "@themesberg/react-bootstrap";

import {
  faArrowAltCircleLeft,
  faMinus,
  faPaperPlane,
  faPlus,
  faPlusCircle,
  faSave,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Category from "../components/Category";
import { currentUser } from "../../../../authentication/auth";
import StockService from "../../../services/StockService";
import LaboratoryService from "../../../services/LaboratoireService";
import LessSidebar from "../../../Shared/LessSidebar";
const LaboStockCategory = (e) => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [category, setCategory] = useState({});
  const [product, setProduct] = useState({});
  const [retourCategory, setRetourCategory] = useState("/laboratory/stock");
  const handleClose = (e) => {
    setShowAddProduct(false);
    setShowAddCategory(false);
    setShowUsedProduct(false);
  };
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const [user, setUser] = useState(null);
  const [agents, setAgents] = useState([]);
  const [reference, setReference] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");
  const [min_quantity_notify, setMinQuantityNotify] = useState("");
  const [last_price_supplier, setLastPriceSupplier] = useState("");
  const [uri, setUri] = useState("");
  const [comment, setComment] = useState("");
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showUsedProduct, setShowUsedProduct] = useState(false);

  const [formUsedProduct, setFormUsedProduct] = useState({
    product_id: "",
    quantity: 1,
    comment: "",
    used_by_id: user?.id,
  });

  const chooseProduct = (product) => {
    setProduct(product);
    setShowUsedProduct(true);
    setFormUsedProduct({
      ...formUsedProduct,
      product_id: product.id,
      used_by_id: currentUser()?.id,
    });
  };

  const addCategory = async (e) => {
    e.preventDefault();
    try {
      const res = await StockService.addCategory({
        name,
        uri,
        ...{ category_id: id },
      });
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        handleClose();
        getCategory();
      }
    } catch (e) {
      NotificationManager.error("error", "Stock");
    }
  };
  const navigate = useNavigate();
  const retirerProduct = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await StockService.retirerProduct(formUsedProduct);
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        setShowUsedProduct(false);
        setLoading(false);
      }
    } catch (e) {
      NotificationManager.error("error", "Stock");

      setLoading(false);
    }
  };
  //const addProduct = (e) => {};
  const resetValues = () => {
    setReference("");
    setName("");
    setDescription("");
    setQuantity("");
    setUnit("");
    setMinQuantityNotify("");
    setUri("");
    setComment("");
  };
  const addProduct = async (e) => {
    e.preventDefault();
    //console.log(reference, name, quantity, comment);
    try {
      const res = await StockService.addProduct({
        reference,
        name,
        quantity,
        description,
        unit,
        min_quantity_notify,
        uri,
        comment,
        ...{ category_id: id },
      });
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        getCategory();
        handleClose();
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getCategory = async () => {
    setLoading(true);
    try {
      const res = await StockService.getCategories(
        `?is_with_product=true&category_id=${id}`
      );
      if (res.status === 200) {
        //NotificationManager.success(res.data.message, "Stock");
        setCategory(res.data.data.list[0]);
        setLoading(false);
        if (res?.data?.data?.list[0]?.category_id) {
          setRetourCategory(
            "/laboratory/stock/category/" +
              res?.data?.data?.list[0]?.category_id
          );
        } else {
          setRetourCategory("/laboratory/stock");
        }
      }
    } catch (e) {
      NotificationManager.error("error", "Stock");
      setLoading(false);
    }
  };

  const getAgents = async () => {
    try {
      const res = await LaboratoryService.getAgents();
      if (res.status === 200) {
        setAgents(res.data.data.list);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
      setFormUsedProduct({ ...formUsedProduct, used_by_id: currentUser()?.id });
    }
    getCategory();
    getAgents();

    // console.log("url retour ===>", retourCategory);
  }, [id]);
  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar user={user} pageName={"Gestion du stock"} icon={faWarehouse} />
        <hr />
        <div>
          <div className="text-end mb-3"></div>
        </div>
        {loading ? (
          <div className="text-center mt-6">
            <Spinner animation="border" />
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-between">
              <Button
                variant={"main"}
                onClick={() => {
                  // console.log("retour link", retourCategory);
                  navigate(retourCategory);
                }}
              >
                <FontAwesomeIcon icon={faArrowAltCircleLeft} /> Retour{" "}
              </Button>

              <Button
                variant={"main"}
                onClick={() => {
                  resetValues();
                  setShowAddProduct(true);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Ajouter Produit{" "}
              </Button>
              <Button
                variant={"main"}
                onClick={() => {
                  resetValues();
                  setShowAddCategory(true);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Ajouter Categorie{" "}
              </Button>
            </div>
            {category && (
              <div className="card mt-3">
                <div className="card-header">
                  <h3>{category?.name}</h3>
                </div>{" "}
              </div>
            )}
            <div className="mt-2">
              <Row>
                {category?.categories?.length > 0 &&
                  category?.categories.map((c) => (
                    <Col md={12} lg={3}>
                      <Category category={c} />
                    </Col>
                  ))}
              </Row>
            </div>
            <div className="card mt-3">
              <div className="card-header">
                <h3>Liste des produits</h3>
                <Table
                  responsive
                  hover={true}
                  className="align-items-center table-flush table-bordered"
                >
                  <thead className="thead-light">
                    <tr>
                      <td>Numero</td>
                      <td>Nom produit</td>
                      <td>Quantite produit</td>
                      <td>Actions</td>
                    </tr>
                  </thead>
                  <tbody>
                    {category?.products?.length > 0 &&
                      category?.products.map((p, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{p.name}</td>
                          <td>
                            {p.quantity} ( {p.unit} ){" "}
                          </td>
                          <td>
                            <Button onClick={() => chooseProduct(p)}>
                              <FontAwesomeIcon icon={faMinus} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>{" "}
            </div>
          </div>
        )}

        <NotificationContainer />
      </main>
      <Modal
        as={Modal.Dialog}
        centered
        show={showAddProduct}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter nouveau produit dans le
            dossier : <strong className="text-main"> {category?.name} </strong>
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={addProduct}>
              <Form.Group className="mb-2">
                <Form.Label>Reference article</Form.Label>
                <Form.Control
                  value={reference}
                  onChange={(e) => setReference(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Nom article</Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Description article</Form.Label>
                <Form.Control
                  as="textarea"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Qunatite article</Form.Label>
                <Form.Control
                  type="number"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Unite article</Form.Label>
                <select
                  className="form-control"
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                >
                  <option>Unite 1</option>
                </select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Prix article</Form.Label>
                <Form.Control
                  type="number"
                  value={last_price_supplier}
                  onChange={(e) => setLastPriceSupplier(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Commentaire article</Form.Label>
                <Form.Control
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                <Button type="submit" variant={"main"}>
                  <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        as={Modal.Dialog}
        centered
        show={showAddCategory}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter nouvelle catégorie dans le
            dossier : <strong className="text-main"> {category?.name} </strong>
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={addCategory}>
              <Form.Group className="mb-2">
                <Form.Label>Nomination </Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Image </Form.Label>
                <Form.Control type="file"></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                <Button type="submit" variant={"main"}>
                  <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        as={Modal.Dialog}
        centered
        show={showUsedProduct}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Retirer du stock le produit :{" "}
            <strong className="text-main"> {product?.name} </strong>
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={retirerProduct}>
              <Form.Group className="mb-2">
                <Form.Label>Reference article</Form.Label>
                <Form.Control
                  value={product.reference}
                  disabled="true"
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Button
                  onClick={() =>
                    setFormUsedProduct({
                      ...formUsedProduct,
                      used_by_id: user?.id,
                    })
                  }
                  variant={`${
                    formUsedProduct.used_by_id === user?.id ? "main" : "primary"
                  } `}
                  className={`ms-2 `}
                >
                  {" "}
                  Labo {user?.first_name}{" "}
                </Button>
                {agents &&
                  agents.map((agent) => (
                    <Button
                      onClick={() =>
                        setFormUsedProduct({
                          ...formUsedProduct,
                          used_by_id: agent?.id,
                        })
                      }
                      variant={`${
                        formUsedProduct.used_by_id === agent?.id
                          ? "main"
                          : "primary"
                      } `}
                      className={`ms-2`}
                    >
                      {" "}
                      {agent.first_name}{" "}
                    </Button>
                  ))}
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Quantite</Form.Label>
                    <Form.Control
                      type="number"
                      step={"0.25"}
                      min={"0.25"}
                      max={product.quantity}
                      value={formUsedProduct.quantity}
                      onChange={(e) =>
                        setFormUsedProduct({
                          ...formUsedProduct,
                          quantity: e.target.value,
                        })
                      }
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Unite</Form.Label>

                    <Form.Control
                      value={product.unit}
                      disabled="true"
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-2">
                <Form.Label>Commentaire</Form.Label>
                <Form.Control
                  as={"textarea"}
                  value={formUsedProduct.comment}
                  onChange={(e) =>
                    setFormUsedProduct({
                      ...formUsedProduct,
                      comment: e.target.value,
                    })
                  }
                ></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                {loading ? (
                  <Button type="submit" variant={"main"}>
                    <Spinner animation="border" />
                  </Button>
                ) : (
                  <Button type="submit" variant={"main"}>
                    <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                  </Button>
                )}
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LaboStockCategory;
